import { render, staticRenderFns } from "./DashboardStoreExpansionalPanel.vue?vue&type=template&id=d54c0306&scoped=true&"
import script from "./DashboardStoreExpansionalPanel.vue?vue&type=script&lang=js&"
export * from "./DashboardStoreExpansionalPanel.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStoreExpansionalPanel.vue?vue&type=style&index=0&id=d54c0306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54c0306",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VExpansionPanel,VExpansionPanelContent,VFlex,VIcon,VLayout,VProgressLinear})
